// extracted by mini-css-extract-plugin
module.exports = {"downloadCSV":"downloadCSV--1hD6i"};